import ArgumentError from './ArgumentError.js';

export default class ArgumentValidator {
  constructor(argumentName, argumentValue) {
    this.argumentName = String(argumentName);
    this.argumentValue = argumentValue;
  }

  /**
   * @param {*} expected
   * @returns {ArgumentValidator}
   * @throws {ArgumentError}
   */
  verifyThatIsEqualTo(expected) {
    if (this.argumentValue !== expected) {
      throw new ArgumentError('Expected ' + this.argumentName + ' to be ' + String(expected));
    }
    return this;
  }

  /**
   * @param {number} expected
   * @returns {ArgumentValidator}
   * @throws {ArgumentError}
   */
  verifyThatIsGreaterThan(expected) {
    if (this.argumentValue <= expected) {
      throw new ArgumentError('Expected ' + this.argumentName + ' to be greater than ' + String(expected));
    }
    return this;
  }

  /**
   * @returns {ArgumentValidator}
   * @throws {ArgumentError}
   */
  verifyThatIsNotEmpty() {
    if (this.argumentValue) return this;
    throw new ArgumentError('Expected ' + this.argumentName + ' not to be empty');
  }

  /**
   * @param {Function} expectedInstance
   * @returns {ArgumentValidator}
   * @throws {ArgumentError}
   */
  verifyInstanceOf(expectedInstance) {
    if (!(this.argumentValue instanceof expectedInstance)) {
      throw new ArgumentError('Expected ' + this.argumentName + ' to be instance of ' + String(expectedInstance.name));
    }
    return this;
  }

  /**
   * @param {string} expectedType
   * @returns {ArgumentValidator}
   * @throws {ArgumentError}
   */
  verifyTypeOf(expectedType) {
    if (typeof this.argumentValue !== expectedType) {
      throw new ArgumentError('Expected ' + this.argumentName + ' to be type of ' + String(expectedType));
    }
    return this;
  }

  /**
   * @param {Array} expectedTypes
   * @returns {ArgumentValidator}
   * @throws {ArgumentError}
   */
  verifyTypesOf(expectedTypes) {
    const argumentValueType = typeof this.argumentValue;
    if (!expectedTypes.some(type => argumentValueType === type)) {
      throw new ArgumentError('Expected ' + this.argumentName + ' to be a type of ' + String(expectedTypes)
        .replace(',', ' or ') + '');
    }
    return this;
  }

  /**
   * @param {RegExp} regExp
   * @returns {ArgumentValidator}
   * @throws {ArgumentError}
   */
  verifyThatMatchesRegExp(regExp) {
    if (!regExp.test(this.argumentValue)) {
      throw new ArgumentError('Expected ' + this.argumentName + ' to match ' + String(regExp));
    }
    return this;
  }
}
